import Image from 'common/components/Image';
import React from 'react';
import { FarmUtils } from 'utils/farmUtils';

export enum TokenName {
  ICHI_LEGACY = 'ichi_legacy',
  XICHI_LEGACY = 'xichi_legacy',
  XICHI_LEGACY_ICHI_LEGACY = 'xichi_legacy_ichi_legacy',
  ICHI_V2 = 'ichi_v2',
  WEENUS = 'weenus',
  OTI = 'oti',
  TOKEN6 = 'Token6'
}

type Props = {
  name: TokenName | string;
  marginLeft?: string;
  marginRight?: string;
  height?: string;
  width?: string;
};

export const TokenIcon: React.FC<Props> = (props) => {
  return (
    <Image
      key={props.name}
      src={FarmUtils.tokenIconSrc(props.name)}
      alt={`${props.name} icon`}
      marginLeft={props.marginLeft}
      marginRight={props.marginRight}
      height={props.height}
      width={props.width}
    />
  );
};
